import {BaseScreen, ScreenDivider, ScreenHeader} from '../Screen';
import {ScreenNames} from '../../../lib/analytics/events';
import {ReactComponent as SecurityIcon} from 'src/assets/icons/security-svgrepo-com.svg';
import React from 'react';

export const SecurityScreen = () => {
    return (
        <>
            <BaseScreen screenName={ScreenNames.SECURITY}>
                <ScreenHeader icon={<SecurityIcon className={'stroke-black'} />} title={'Security'} />
                <ScreenDivider />
                <div className='flex h-screen flex-col p-10'>
                    <h5 className='mb-2 text-[20px] font-bold'>Hotlinking Protection</h5>
                    <p className='text-[16px]'>
                        We offer Referer header whitelisting, allowing you to control which domains can directly access
                        your content. This powerful tool minimizes the risk of hotlinking, which can drain your
                        bandwidth.
                    </p>
                    <br />
                    <p>
                        Feel free to submit your request for whitelisting your preferred custom domains and referer
                        headers to us at{' '}
                        <a className={'text-blue-500'} href='mailto:support@perceptpixel.com'>
                            support@perceptpixel.com
                        </a>{' '}
                        to activate this protection.
                        <a
                            className={'text-blue-500'}
                            target={'_blank'}
                            href='https://perceptpixel.com/docs/security'
                            rel='noreferrer'>
                            {' '}
                            Read more
                        </a>
                    </p>
                    <p>
                        For instance, if you wish to grant access to Facebook (or any other social network) for fetching
                        your images, ensure to include the pertinent referer headers in the provided list.
                    </p>
                    <br />
                    <p>
                        <span className={'font-bold'}>Note</span>: Currently, hotlinking protection can only be applied
                        to custom domain URLs within PerceptPixel's CDN. For more details on how to configure custom
                        domains, please refer the documentations provided
                        <a
                            className={'text-blue-500'}
                            target={'_blank'}
                            href='https://perceptpixel.com/docs/custom-domains'
                            rel='noreferrer'>
                            {' '}
                            here
                        </a>
                        .
                    </p>
                </div>
            </BaseScreen>
        </>
    );
};
